export default {"src":"/_next/static/media/deco_bonus_cash.693460f4.svg","height":33,"width":54,"blurWidth":0,"blurHeight":0};